// for assign employee

export const RESER_ASSIGN_EMPLOYEE = "resign_assign_employee";
export const ASSIGN_EMPLOYEE = "assign_employee";
export const ASSIGN_EMPLOYEE_SUCCESS = "assign_employee_success";
export const ASSIGN_EMPLOYEE_FAILURE = "assign_employee_failure";
